module.exports = __webpack_public_path__ + "media/components/blocks/ProUpsell/feature_check-752fc17b864b1981b77f5cc2ce2ba0c0.png";